<template>
  <div class="pd-20 pos-relative" style="height: calc(100vh - 150px);">
    <div style="position: absolute; bottom: 20px; right:0" class="btn-group">
      <a @click="addTopic()" role="button" class="btn btn-xs btn-primary">Сэдэв үүсгэх</a>
      <a @click="$router.go(-1)" role="button" class="btn btn-xs btn-info">Буцах</a>
    </div>
    <ul class="list-group">
      <li
        @click="$emit('on-detail', t)"
        class="list-group-item d-flex align-items-center"
        v-for="(t, i) in topics"
        :key="i"
        role="button"
      >
        <!-- <div class="avatar">
          <span :class="`avatar-initial rounded-circle op-5 bg-primary`">
            {{ t.commentCount }}
          </span>
        </div> -->
        <div class="bd-r w-40 pd-r-10 text-center">
          <div class="tx-14 tx-semibold">{{ t.commentCount }}</div>
          <div class="text-muted">хариулт</div>
        </div>
        <div class="pd-l-10">
          <h6 class="tx-13 tx-inverse tx-semibold mg-b-0">{{ t.task }}</h6>
          <span class="d-block tx-11 text-muted">{{
            t.createdDate | moment("LLLL")
          }}</span>
        </div>
      </li>
    </ul>

    <b-modal v-model="taskModal" title="Сэдэв үүсгэх" hide-footer>
      <div class="row align-items-center flex-nowrap">
        <div class="col-sm-2">Сэдэв:</div>
        <div class="col-sm-10">
          <input v-model="taskModel.task" type="text" class="form-control" placeholder="Сэдэв бинэ үү">
        </div>
      </div>
      <div class="row align-items-center flex-nowrap">
        <div class="col-sm-12">
          <a @click="saveTopic()" role="button" class="btn btn btn-success">Хадгалах</a>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { request } from "@/api/all";

export default {
  props: {
    task: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      topics: [],
      taskModel:{
        task: null,

      },
      taskModal: false,
      boxId: null,
      projectId: null,
    };
  },
  mounted() {
    //console.log(this.task);
    this.init();
  },
  methods:{
    init(){
      let tb = this.task.b.filter(x => x.ot == 125);
      if (tb.length) {
        this.boxId= tb[0].id;
        this.projectId= tb[0].projectId;
        //console.log(tb[0]);
        this.$emit("on-toggle-class", {
          mode: "addClass",
          class: "dynamic-locker"
        });
        request({
          api: { method: "POST", url: "taskCore/coreBoxInTaskList" },
          data: { id: tb[0].id, skip: 0, size: 100 },
          store: this.$store
        }).then(res => {
          //this.toggleBodyClass('removeClass', 'dynamic-locker');
          this.$emit("on-toggle-class", {
            mode: "removeClass",
            class: "dynamic-locker"
          });
          if (res != false) {
            this.topics = res.data.tasks;
            //console.log('coreBoxInTaskList=> ', res.data);
          }
        });
      }
    },
    addTopic(){
      // let _pid = 0;
      // let prj = this.$store.state.app.groupDefaultProjects.filter( (x) => x.objectTypeId == parseInt(125, 10) );
      // console.log('prj', this.task,prj, this.$store.state.app.groupDefaultProjects.map((e)=>e.objectTypeId).flat());
      // if (prj.length > 0) _pid = prj[0].id;

      this.$emit("on-toggle-class", { mode: "addClass", class: "dynamic-locker" });
      request({
        api: { method: "GET", url: "Task/GetInherited" },
        params: {
          id: 0,
          objectTypeId: 125,
          parentId: 0,
          projectId: this.projectId,
          boxId: this.boxId,
          userId: this.$store.state.user.userInfo.userId,
        },
        store: this.$store
      }).then(res => {
        this.$emit("on-toggle-class", { mode: "removeClass", class: "dynamic-locker"});
        if (res != false) {
          this.taskModel= res.data.task;
          //console.log('res.data.task', res.data.task.projectId);
          this.taskModal= true;
        }
      });
    },
    saveTopic(){
      this.$emit("on-toggle-class", { mode: "addClass", class: "dynamic-locker" });
      this.taskModel.isPublic= true;
      this.taskModel.boxId= this.boxId;
      this.taskModel.projectId= this.projectId;
      // console.log('this.taskModel.projectId', this.taskModel.projectId);
      request({
        api: { method: "POST", url: "Task/PostInherited" },
        data: { model: this.taskModel },
        store: this.$store
      }).then(res => {
        this.$emit("on-toggle-class", { mode: "removeClass", class: "dynamic-locker"});
        if (res != false) {
          this.init();
          this.taskModal=false;
        }
      });
    }
  }
};
</script>

<style></style>
